/* eslint-disable import/prefer-default-export */
import cx from 'classnames'
import { map, some } from 'lodash'
import * as React from 'react'
import { matchPath, NavLink, useLocation } from 'react-router-dom'
import { getHtmlSelectorValueBy } from '@src/utils/css.selector.helper'
import { MenuItemData } from '../../configurations'
import * as styles from '../../sidebar.layout.styl'
import { MenuItem } from '../menu.item'

export interface ExpandSectionProps {
  className?: string
  isCollapsed?: boolean
  expanded?: boolean
  to?: string
  items: MenuItemData[]
}

export interface ExpandSectionBodyProps {
  onClick: (event?: React.MouseEvent<HTMLElement, MouseEvent>) => void
  className: string
}

export const ExpandSectionBody: React.FC<ExpandSectionBodyProps> = ({
  children,
  className,
  onClick
}: React.PropsWithChildren<ExpandSectionBodyProps>) => (
  <div onClick={onClick} className={className}>
    {children}
  </div>
)

export const Expander: React.FC<{ expanded: boolean }> = ({
  expanded
}: {
  expanded: boolean
}) =>
  expanded ? (
    <i className="material-icons">keyboard_arrow_up</i>
  ) : (
    <i className="material-icons">keyboard_arrow_down</i>
  )

export const ExpandSection: React.FC<ExpandSectionProps> = ({
  children,
  className,
  items,
  isCollapsed,
  to,
  expanded
}: React.PropsWithChildren<ExpandSectionProps>) => {
  const location = useLocation()
  const activeSection = isActive(items)
  const [expandedMenu, toogleExpand] = React.useState(expanded || activeSection)
  React.useEffect(() => {
    const activeSection = isActive(items)
    if (activeSection) {
      toogleExpand(true)
    }
    if (expanded && expanded !== expandedMenu) {
      toogleExpand(expanded)
    }
  }, [expanded, items, location])

  function onToogleExpand() {
    toogleExpand(!expandedMenu)
  }

  function isActive(items: MenuItemData[] = []) {
    return some(items, x =>
      matchPath(location?.pathname, {
        exact: true,
        path: x.path || `/${x.url}`
      })
    )
  }
  const { 0: first } = items || []
  const rootUrl = to || `/${first?.url}`
  const Component = expandedMenu || activeSection ? ExpandSectionBody : NavLink
  return (
    <div
      className={cx(className, styles.expandedMenuItemContainer, {
        [styles.expanded]: expandedMenu,
        [styles.active]: activeSection
      })}
    >
      <>
        <Component
          to={rootUrl}
          onClick={onToogleExpand}
          className={cx(styles.expandMenuItem, {
            [styles.active]: expandedMenu
          })}
        >
          <>
            {children}
            {!isCollapsed && (
              <div className={styles.expandSectionIcon}>
                <Expander expanded={expandedMenu} />
              </div>
            )}
          </>
        </Component>
        {expandedMenu && (
          <div className={styles.expandedSubMenuItems}>
            {map(items, (x, i) => (
              <div
                key={`item-${x.url}-${i}`}
                className={cx({ disabled: x.disabled })}
              >
                <NavLink
                  to={`/${x.url}`}
                  activeClassName={styles.active}
                  id={getHtmlSelectorValueBy(`${x.title}Nav`)}
                >
                  <MenuItem
                    {...x}
                    collapsedClassName={styles.collapsedItem}
                    isCollapsed={isCollapsed}
                    selector={
                      (isCollapsed
                        ? x?.selector
                        : x?.selectorCollapsed || '') ||
                      getHtmlSelectorValueBy(x?.url, '', '-') ||
                      (x?.title || '').toLocaleLowerCase()
                    }
                  />
                </NavLink>
              </div>
            ))}
          </div>
        )}
      </>
    </div>
  )
}
